export default {
  functional: true,

  name: 'list-tile-action',

  props: {
    narrow: Boolean,
    noStack: Boolean,
  },

  render (h, context) {
    context.data.staticClass = context.data.staticClass
     ? context.data.staticClass + ' '
     : ''

    const classes = {
      'list__tile__action': true,
      'list__tile__action--narrow': context.props.narrow,
      'list__tile__action--stack': context.props.noStack == false && (context.children || []).length > 1
    }

    context.data.staticClass += Object.keys(classes).filter(k => classes[k] == true).join(' ')

    return h('div', context.data, context.children)
  }
}